import { useEffect } from 'react';
import { useIMask } from 'react-imask';
import { Input } from '@geely/ui';

interface MaskedVinInputProps {
  value: string;
  onChange: (value: string) => void;
  name: string;
}

export function MaskedVinInput({ value, onChange, name }: MaskedVinInputProps) {
  const { ref, setValue } = useIMask<HTMLInputElement>(
    {
      mask: 'vvvvvvvvvvvvvvvvv',
      definitions: {
        v: /[A-HJ-NPR-Z0-9]/,
      },
      prepare: (str: string) => str.toUpperCase(),
    },
    { onAccept: (maskedValue: string) => onChange(maskedValue) }
  );

  useEffect(() => {
    if (value) {
      setValue(value);
    }
  }, [value, setValue]);

  return <Input ref={ref} name={name} placeholder="Ex: 9BWHE21JX24060831" />;
}
